module.exports = __webpack_public_path__ + "img/clients3-479.cd1d32c.png";